import initialState from 'src/store/state'

// Target State
const moduleState = initialState.questions

// Actions
const ADD_QUESTION = 'ADD_QUESTION'
const SET_ANSWER = 'SET_ANSWER'
const SET_ENTERED = 'SET_ENTERED'
const SET_DISABLED = 'SET_DISABLED'
const SET_MAKER = 'SET_MAKER'
const SET_MODEL = 'SET_MODEL'
const SET_TIRE_WIDTH = 'SET_TIRE_WIDTH'
const SET_RESULT_Q = 'SET_RESULT_Q'
const SET_RESULT_NEXT = 'SET_RESULT_NEXT'
const SET_RESULT_OTHER = 'SET_RESULT_OTHER'
const CLEAR_ANSWERS = 'CLEAR_ANSWERS'
const SET_NEXT = 'SET_NEXT'

// Action Creators
export const addQuestion = (data:object) => {
  return {
    type: ADD_QUESTION,
    payload: { data }
  }
}

export const setAnswer = (data:object) => {
  return {
    type: SET_ANSWER,
    payload: { data }
  }
}

export const setEntered = (data:object) => {
  return {
    type: SET_ENTERED,
    payload: { data }
  }
}

export const setDisabled = (data:object) => {
  return {
    type: SET_DISABLED,
    payload: { data }
  }
}

export const setMaker = (data:object) => {
  return {
    type: SET_MAKER,
    payload: { data }
  }
}

export const setModel = (data:object) => {
  return {
    type: SET_MODEL,
    payload: { data }
  }
}
export const setTireWidth = (data:object) => {
  return {
    type: SET_TIRE_WIDTH,
    payload: { data }
  }
}
export const setResultQ = (data:object) => {
  return {
    type: SET_RESULT_Q,
    payload: { data }
  }
}

export const setResultNext = (data:object) => {
  return {
    type: SET_RESULT_NEXT,
    payload: { data }
  }
}

export const setResultOther = (data:object) => {
  return {
    type: SET_RESULT_OTHER,
    payload: { data }
  }
}

export const clearAnswers = (data:object) => {
  return {
    type: CLEAR_ANSWERS,
    payload: { data }
  }
}

export const setNext = (data:object) => async (dispatch) => {
  dispatch({
    type: SET_NEXT,
    payload: { data }
  })
}

// Reducers
const reducers = (state = moduleState, action: any) => {
  switch (action.type) {
    case ADD_QUESTION: {
      const data = action.payload.data
      // if(data.id === 'btn_result_action' && data.custom !== 'result') data.id = data.custom
      state[data.id] = data
      return Object.assign({}, state)
    }

    case SET_ANSWER: {
      const data = action.payload.data
      if (data.matchValue) {
        state[data.props.id].questions.forEach((item) => {
          item.checked = (item.value === data.matchValue)
        })
      } else {
        state[data.props.id].questions[data.iterator].checked = data.checked
      }
      return Object.assign({}, state)
    }

    case SET_ENTERED: {
      const data = action.payload.data
      if (state[data.props.id]) {
        state[data.props.id].isEntered = data.isEntered
      }
      return Object.assign({}, state)
    }

    case SET_DISABLED: {
      const data = action.payload.data
      if (state[data.props.id]) {
        state[data.props.id].questions[data.iterator].disabled = data.disabled
      }
      return Object.assign({}, state)
    }

    case SET_MAKER: {
      const data = action.payload.data
      state[data.props.id].questions = data.maker_data
      return Object.assign({}, state)
    }

    case SET_MODEL: {
      const data = action.payload.data
      state[data.props.id].questions2 = data.model_data
      return Object.assign({}, state)
    }

    case SET_TIRE_WIDTH: {
      const data = action.payload.data
      state[data.props.id].questions = data.tire_width_data
      state[data.props.id].questions2 = data.flat_data
      state[data.props.id].questions3 = data.rim_data
      return Object.assign({}, state)
    }

    case SET_RESULT_Q: {
      const data = action.payload.data
      state[data.props.id].questions = data.questions
      return Object.assign({}, state)
    }

    case SET_RESULT_NEXT: {
      const data = action.payload.data
      state[data.props.id].next = data.next
      return Object.assign({}, state)
    }

    case SET_RESULT_OTHER: {
      const data = action.payload.data
      state[data.props.id] = data.other
      return Object.assign({}, state)
    }

    case CLEAR_ANSWERS: {
      const data = action.payload.data
      state[data.id].isEntered = false
      state[data.id].questions && state[data.id].questions.forEach((item) => {
        if (item.checked) {
          item.checked = false
        }
        if (item.disabled) {
          item.disabled = false
        }
      })
      return Object.assign({}, { ...state })
    }

    case SET_NEXT: {
      const data = action.payload.data
      const keys = Object.keys(data)
      keys.forEach((key) => {
        state[key].next = data[key]
      })
      // state[data.key].next = data.next
      return Object.assign({}, state)
    }

    default:
      return state
  }
}

export default reducers
